<template>
  <input
    ref="input"
    type="file"
    accept="image/*"
    @change="onFileChange"
    class="resizefile_input"
    :disabled="disabled"
  />
</template>

<script>
import blueImp from 'blueimp-load-image'

export default {
  name: 'ResizeImageInput',
  props: {
    maxSize: {
      type: Number,
      default: 1024,
    },
    disabled: {
      type: Boolean,
      boolean: false,
    },
  },
  methods: {
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files
      this.resizeImage(files[0])
    },
    resizeImage(file) {
      blueImp.parseMetaData(file, data => {
        const options = {
          canvas: true,
          maxHeight: this.maxSize,
          maxWidth: this.maxSize,
        }
        if (data.exif) {
          options.orientation = data.exif.get('Orientation')
        }
        blueImp(
          file,
          canvas => {
            const base64 = canvas.toDataURL('image/jpeg')
            this.$emit('resized', { blob: this.toBlob(base64, file.type) })
          },
          options,
        )
      })
    },
    toBlob(base64, type) {
      const bin = atob(base64.replace(/^.*,/, ''))
      const tmpBuffer = new Uint8Array(bin.length)
      const buffer = tmpBuffer.map((item, index) => bin.charCodeAt(index))
      try {
        const blob = new Blob([buffer.buffer], { type })
        return blob
      } catch (e) {
        return false
      }
    },
  },
}
</script>

<style scoped>
.resizefile_input {
  display: none;
}
</style>
